const Height = {
  viewport: 'calc(100vh - 95px)' /* 95px being the height of the nav */, // not taking in account native UI on android/iOS, 'svh' will help with this when we support it
  auto: 'auto',
  'fit-content': 'fit-content',
} as const;

export default Height;
